export enum ServiceStatusSearchType {
  BY_ACCOUNT_ID = 'FULLY_IDENTIFIED',
  BY_POSTCODE = 'POSTCODE_ONLY',
}

export interface ServiceStatusSearchOptions {
  postcode: string;
  lastName: string;
  house: string;
}

export interface SelfCareIdentifyAccountResponse {
  success: Success;
}

export interface Success {
  customerAccount: CustomerAccount;
  identifyOutcomeCode: SelfCareIdentifyAccountOutcomeCodes;
}

export interface CustomerAccount {
  accountIdentification: AccountIdentification;
  accountActive: boolean;
  accountStatus: string;
  accountType: string;
  postcode: string;
  telephoneNumber: string[];
}

export interface AccountIdentification {
  accountNumber: string;
  siteReference: string;
}

export enum SelfCareIdentifyAccountOutcomeCodes {
  SINGLE_ACCOUNT_FOUND = '01401',
  MULTIPLE_ACCOUNTS_FOUND = '01441',
  NO_ACCOUNT_FOUND = '01444',
}

export enum ServiceStatusCategoryMap {}

export interface PageContent {
  pageHeading: string;
  formHeading: string;
  formFooter: string;
  footerLinkText: string;
  footerLink: any;
}

/***************** Service Status Session starts */
export enum IdentificationStatusType {
  FULLY_IDENTIFIED = 'FULLY_IDENTIFIED',
  POSTCODE_IDENTIFIED = 'POSTCODE_IDENTIFIED',
  NOT_IDENTIFIED = 'NOT_IDENTIFIED',
}

export interface ServiceStatusSessionResponse {
  data: null;
  emailAddress: null;
  findByCustomerDetailsMailAddresses: null;
  selectedProductId: null;
  selectedProductType: null;
  angularPublicSession: angularPublicSession;
}

export interface angularPublicSession {
  accountStatus?: null;
  angularSelectBoxView?: angularSelectBoxView;
  appointmentDate?: null;
  appointmentTime?: null;
  areaFault?: null;
  description?: null;
  diagnosticIdentifier?: null;
  einsteinActionCode1?: null;
  einsteinActionCode2?: null;
  estimatedResolutionDate?: null;
  futureAppointmentDate?: null;
  householdId?: null;
  identificationStatus?: IdentificationStatusType;
  kitArrivalDate?: any;
  numberOfIssueDevices?: any;
  postcode?: string;
  remainingMinutes?: null;
  serviceStatusResponse?: ServiceStatusResponse;
  unidentifiedModelToFix?: null;
  waitTime?: any;
}

export interface ServiceStatusResponse {
  identificationStatus: string;
  customerAccountAndCollectionStatus: string;
  currentOutagesByProductType: CurrentOutagesByProductType;
  plannedOutageList: any[];
}

export interface CurrentOutagesByProductType {
  TV: SubscribedServiceType;
  BROADBAND: SubscribedServiceType;
  PHONE: SubscribedServiceType;
}

export interface SubscribedServiceType {
  autoCompensationOutageId: string;
  outages: Outage[];
}

export interface Outage {
  outageId: string;
  description: string;
  outageStatus: string;
  estimatedResolutionDate: Date;
  ticketNumber: string;
}
/***************** Service Status Session ends */

export interface angularSelectBoxView {
  obfuscatedTvBoxes: obfuscatedTvBoxes;
}

export interface obfuscatedTvBoxes {
  [key: string]: obfuscatedTvBoxDetails;
}

export interface obfuscatedTvBoxDetails {
  obfuscatedSerialNumber: string;
  deviceDescription: string;
  hasIssues: string;
}
